/* Kardhini — Splide bootstrapping.

   Every carousel is declared in Liquid as [data-k-splide] carrying a JSON
   options blob, so section markup stays free of inline <script> and the
   theme editor can re-init a section after it re-renders. */

(function () {
  'use strict';

  var MOUNTED = 'data-k-splide-mounted';

  function optionsFor(el) {
    var base = {
      arrows: false,
      pagination: false,
      gap: '1.6rem',
      speed: 500,
      easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
    };
    try {
      var raw = el.getAttribute('data-k-splide');
      if (raw) Object.assign(base, JSON.parse(raw));
    } catch (e) {
      // A malformed blob should degrade to a working default carousel,
      // not take the whole page's JS down.
      console.warn('[kardhini] bad splide options', e);
    }
    return base;
  }

  // The reference shows a thin progress rail rather than dots.
  function wireRail(splide, root) {
    var bar = root.querySelector('[data-k-rail-bar]');
    if (!bar) return;

    function update() {
      // Components only exist once mounted. Guard, because this also runs
      // on 'resized' which can fire during teardown in the theme editor.
      var ctrl = splide.Components && splide.Components.Controller;
      if (!ctrl) return;

      var end = ctrl.getEnd() + 1;
      var perPage = splide.options.perPage || 1;
      var visible = Math.min(perPage / (end + perPage - 1), 1);
      var rate = end > 1 ? splide.index / (end - 1) : 0;
      var width = Math.max(visible * 100, 8);
      bar.style.width = width + '%';
      bar.style.left = rate * (100 - width) + '%';
    }

    // Register only — never call update() before mount(). Doing so throws on
    // the missing Controller, which aborts mount() and leaves the carousel
    // stuck at Splide's default visibility:hidden.
    splide.on('mounted move resized', update);
  }

  function mount(root) {
    if (!window.Splide || root.hasAttribute(MOUNTED)) return;
    root.setAttribute(MOUNTED, '');
    try {
      var splide = new window.Splide(root, optionsFor(root));
      wireRail(splide, root);
      splide.mount();
      // Exposed so the tab filter can refresh the carousel after it swaps
      // which slides are in the list.
      root.kSplide = splide;
    } catch (e) {
      // Splide leaves the element hidden if it never initialises, so make
      // sure a failure degrades to the plain scroller rather than a blank gap.
      console.warn('[kardhini] splide mount failed', e);
      root.classList.add('k-splide-failed');
    }
  }

  function mountAll(scope) {
    (scope || document).querySelectorAll('[data-k-splide]').forEach(mount);
  }

  function boot() {
    if (!window.Splide) {
      // Splide is deferred too; if it has not parsed yet, wait for load.
      window.addEventListener('load', function () { mountAll(); }, { once: true });
      return;
    }
    mountAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Theme editor re-renders a section's DOM wholesale — remount inside it.
  document.addEventListener('shopify:section:load', function (e) { mountAll(e.target); });
})();
